/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FinchConnectionStatus {
  CONNECTED = 'CONNECTED',
  PENDING = 'PENDING',
  DISCONNECTED = 'DISCONNECTED',
  REAUTHENTICATE = 'REAUTHENTICATE',
  ERROR = 'ERROR',
}
